import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { generateMockDoor } from 'mocks/graphqlMocks/door';

export function mockedAssignAccessGrantsToDoors(
  assignAccessGrantsToDoors: AccessGrant[]
): Pick<Mutation, 'assignAccessGrantsToDoors'> {
  return {
    assignAccessGrantsToDoors
  };
}

export const mockedAssignAccessGrantsToDoorsDataForMutation = mockedAssignAccessGrantsToDoors([
  generateMockAccessGrant({ id: 'mockedAccessGrantId', doors: [generateMockDoor({ id: 'mockedDoorId' })] })
]);
